import React from 'react';
import PropTypes from 'prop-types';
import { DesktopStepperForm } from 'components/elements/stepper/DesktopStepperForm';
import { TabletStepperForm } from 'components/elements/stepper/TabletStepperForm';
import { useDeviceDetect } from 'hooks';

function StepperForm({ activeStep, steps, children, navigation }) {
  const { isDesktop } = useDeviceDetect();
  return isDesktop ? (
    <DesktopStepperForm activeStep={activeStep} steps={steps} navigation={navigation}>
      {children}
    </DesktopStepperForm>
  ) : (
    <TabletStepperForm activeStep={activeStep} steps={steps} navigation={navigation}>
      {children}
    </TabletStepperForm>
  );
}
StepperForm.propTypes = {
  activeStep: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
  navigation: PropTypes.element.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default StepperForm;
